import React from 'react';
import ReactDOM from 'react-dom';

export const selectNodeText = el => {
  if (el.select) {
    el.select();
  } else if (document.body.createTextRange) {
    const range = document.body.createTextRange();

    range.moveToElementText(el);
    range.select();
  } else if (window.getSelection) {
    const range = document.createRange();

    range.selectNodeContents(el);

    const selection = window.getSelection();

    selection.removeAllRanges();
    selection.addRange(range);
  }
};

export const copy = (el, { asHtml = false } = {}) => {
  try {
    if (asHtml) {
      return copyHtml(el);
    }

    selectNodeText(el);
    window.document.execCommand('copy');

    // the following is needed for on-page-load copying in new chrome versions,
    // and does not break on-click copying:
    const text = el.value || el.textContent;

    if (text) {
      navigator?.clipboard?.writeText(text).catch(() => {});
    }

    return true;
  } catch (e) {
    return false;
  }
};

export const copyText = text => {
  try {
    const prevFocusedEl = window.document.activeElement;

    const el = window.document.createElement('textarea');

    el.value = text;
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    window.document.body.appendChild(el);
    el.select();
    window.document.execCommand('copy');
    window.document.body.removeChild(el);

    // Chrome-specific copying
    navigator?.clipboard?.writeText(text).catch(() => {});

    if (prevFocusedEl) {
      prevFocusedEl.focus();
    }

    return true;
  } catch (e) {
    return false;
  }
};

function createMarkElForHtml(html) {
  const mark = document.createElement('div');

  mark.innerHTML = html;

  return mark;
}

function copyHtml(node) {
  let success = true;
  const mark = createMarkElForHtml(node.innerHTML);

  try {
    const range = document.createRange();
    const selection = document.getSelection();

    document.body.appendChild(mark);

    range.selectNode(mark);

    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
  } catch (err) {
    success = false;
  }

  if (mark) {
    document.body.removeChild(mark);
  }

  return success;
}

export const copyComponent = async ComponentFn => {
  const fragment = document.createElement('div');

  const renderSuccess = await new Promise(resolve => {
    let completed = false;
    const timeout = window.setTimeout(() => {
      if (completed === false) {
        resolve(false);
        completed = true;
      }
    }, 2000);

    ReactDOM.render(<ComponentFn />, fragment, () => {
      if (completed === true) {
        return;
      }

      resolve(true);
      completed = true;
      window.clearTimeout(timeout);
    });
  });

  if (renderSuccess === false) {
    return;
  }

  copy(fragment, { asHtml: true });
};
